// src/features/trainings/TrainingsModule.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import TrainingsList from './TrainingsList';
import TrainingForm from './TrainingForm';
import TrainingProfile from './TrainingProfile';

/**
 * Módulo de Capacitaciones
 * Maneja las rutas y componentes para el módulo de Capacitaciones
 */
function TrainingsModule() {
  return (
    <Routes>
      {/* Ruta base: muestra la lista de capacitaciones */}
      <Route index element={<TrainingsList />} />
      
      {/* Ruta para crear nueva capacitación */}
      <Route path="add" element={<TrainingForm />} />
      
      {/* Ruta para editar una capacitación existente */}
      <Route path=":id/edit" element={<TrainingForm />} />
      
      {/* Ruta para ver perfil de capacitación */}
      <Route path=":id" element={<TrainingProfile />} />
    </Routes>
  );
}

export default TrainingsModule;